import http from 'hub-http/clients/apiClient';
import { deleteAccountRpc } from '../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AccountRpc';
import { useListSupportedAppsQuery as useListSupportedAppsQueryGenerated } from '../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AppRpc.hooks';
import { useListAccountsForAppQuery as useListAccountsForAppQueryGenerated } from '../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AccountRpc.hooks';
import { createRpcClientV2 } from 'rpc-client-utils';

// Import and re-export types for convenience

export function useListSupportedAppsQuery(options) {
  return useListSupportedAppsQueryGenerated({
    context: options !== null && options !== void 0 && options.timeout ? {
      timeout: options.timeout
    } : undefined
  });
}
export function useListAccountsForAppQuery(appId, options) {
  return useListAccountsForAppQueryGenerated({
    variables: {
      appId
    },
    context: options !== null && options !== void 0 && options.timeout ? {
      timeout: options.timeout
    } : undefined
  });
}

// Create RPC client for imperative calls
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Deletes a unified account
 */
export function deleteAccount(accountId) {
  return chirpClient.call(deleteAccountRpc, {
    request: {
      accountId
    }
  });
}

// Generic Result type for algebraic data type handling

// Success response type

// Error response type

// Combined response type

/**
 * Creates a new unified account
 */
export function createAccount(portalId, createAccountRequest) {
  return http.post('/api/unified-account/v1/account/create', {
    data: createAccountRequest,
    query: {
      portalId
    }
  });
}